// 所属服务 serviceTool 业务工具,publicTool 公共工具
const service = "serviceTool";
// 前台路由
const web_routers = [
  {
    path: "lightApps",
    name: "lightApps",
    component: () =>
      import(
        /* webpackChunkName: "[request]" */ "@layouts/forestage/appCenterLayout"
      ),
    redirect: { name: "applicationCenter" },
    meta: {
      title: "应用中心",
    },
    children: [
      {
        path: "calendar",
        name: "calendar",
        component: () => import("../../forestage/calendar"),
        meta: {
          title: "日程",
          showFoot: false,
          hide: true,
        },
      },
      {
        path: "applicationCenter",
        name: "applicationCenter",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../views/forestage/applicationCenter/ApplicationCenter.vue"
          ),
        meta: {
          title: "应用中心",
          icon: "icon-shujuguanli",
          showFoot: false,
          hide: true,
        },
      },
      {
        path: "myNetworkDisk",
        name: "myNetworkDisk",
        redirect: {
          name: "myFile",
        },
        component: () =>
          import("../../layouts/forestage/MyNetworkDiskLayout.vue"),
        meta: {
          title: "我的网盘",
        },
        children: [
          {
            path: "myFile",
            name: "myFile",
            component: () =>
              import("../../forestage/myNetworkDisk/myFile/MyFile.vue"),
            meta: {
              title: "我的文件",
            },
          },
          {
            path: "recyclingStation",
            name: "recyclingStation",
            component: () =>
              import(
                "../../forestage/myNetworkDisk/recyclingStation/RecyclingStation.vue"
              ),
            meta: {
              title: "回收站",
            },
          },
          {
            path: "myShare",
            name: "myShare",
            component: () =>
              import("../../forestage/myNetworkDisk/myShare/MyShare.vue"),
            meta: {
              title: "分享",
            },
          },
          {
            path: "sharedSpace",
            name: "sharedSpace",
            component: () =>
              import(
                "../../forestage/myNetworkDisk/sharedSpace/SharedSpace.vue"
              ),
            meta: {
              title: "共享空间",
            },
          },
        ],
      },
      {
        path: "publishMessage",
        name: "publishMessage",
        redirect: { name: "PublishMessage" },
        component: {
          render: (e) => e("router-view"),
        },
        meta: {
          title: "信息发布",
          icon: "icon-xiaoxi",
          showFoot: false,
        },
        children: [
          {
            path: "TemplateLibrary",
            name: "TemplateLibrary",
            component: () =>
              import(
                "@/views/forestage/appCenter/publishMessage/TemplateLibrary"
              ),
            meta: {
              title: "模板管理",
              icon: "icon-shuju",
              showFoot: false,
              showSide: true,
            },
          },
          {
            path: "edit",
            name: "MessageEdit",
            component: () =>
              import("@/views/forestage/appCenter/publishMessage/MessageEdit"),
            meta: {
              title: "信息编辑",
              icon: "icon-zuji",
              showFoot: false,
              showSide: false,
              hide: true,
            },
          },
          {
            path: "preview",
            name: "MessagePreview",
            component: () =>
              import(
                "@/views/forestage/appCenter/publishMessage/MessagePreview"
              ),
            meta: {
              title: "信息预览",
              icon: "icon-zuji",
              showFoot: false,
              hideHeader: true,
              showSide: false,
              hide: true,
            },
          },
          {
            path: "detail",
            name: "publishDetails",
            component: () =>
              import(
                "@/views/forestage/appCenter/publishMessage/MessageDetails"
              ),
            meta: {
              title: "信息详情",
              icon: "icon-zuji",
              showFoot: false,
              showSide: false,
              hide: true,
            },
          },
          {
            path: "PublishMessage",
            name: "PublishMessage",
            component: () =>
              import(
                "@/views/forestage/appCenter/publishMessage/PublishMessage"
              ),
            meta: {
              title: "信息发布",
              icon: "icon-wendang",
              showFoot: false,
              showSide: true,
            },
          },
          {
            path: "MyRelease",
            name: "MyRelease",
            component: () =>
              import(
                "@/views/forestage/appCenter/publishMessage/PublishMessage"
              ),
            meta: {
              title: "我的发布",
              icon: "icon-wendang",
              showFoot: false,
              showSide: true,
            },
          },
          // {
          //   path: "TagsManage",
          //   name: "TagsManage",
          //   component: () =>
          //     import("@/views/forestage/appCenter/publishMessage/TagsManage"),
          //   meta: {
          //     title: "标签管理",
          //     icon: "icon-zuji",
          //     showFoot: false,
          //     showSide: true,
          //   },
          // }
        ],
      },
    ],
  },
  {
    path: "navPortal",
    name: "navPortal",
    component: () =>
      import(
        /* webpackChunkName: "[request]" */ "../views/forestage/Detail.vue"
      ),
  },
];

// 后台路由
const cms_routers = {
  path: "lightApps",
  name: "cmsLightApps",
  component: () =>
    import(
      /* webpackChunkName: "[request]" */ "../../bi/layouts/backstage/BiLayout"
    ),
  redirect: { name: "visualPortal" },
  meta: {
    title: "轻应用中心",
  },
  children: [
    {
      path: "visualPortal",
      name: "visualPortal",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/visualPortal/VisualPortal.vue"
        ),
      meta: {
        title: "轻应用中心",
        icon: "icon-shujuguanli",
        layout: false,
      },
    },
    {
      path: "visualPortalManagement",
      name: "visualPortalManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/visualPortalManagement/VisualPortalManagement.vue"
        ),
      meta: {
        title: "轻应用中心管理",
        icon: "",
        head: false,
        layout: false,
      },
    },
    {
      path: "visualPortalDetail",
      name: "visualPortalDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/visualPortalDetail/VisualPortalDetail.vue"
        ),
      meta: {
        title: "轻应用中心预览",
        icon: "",
        head: false,
        layout: false,
      },
    },
    // 以上是从BI服务拆分出来的路由 菜单名称因为涉及很多引用关系所以未更改名称
    {
      path: "tinyAppDeactivate",
      name: "tinyAppDeactivate",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/tinyAppDeactivate/TinyAppDeactivate.vue"
        ),
      meta: {
        title: "已停用",
        icon: "",
        layout: false,
      },
    },
    {
      path: "tinyAppDraftbox",
      name: "tinyAppDraftbox",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/tinyAppDraftbox/TinyAppDraftbox.vue"
        ),
      meta: {
        title: "草稿箱",
        icon: "",
        layout: false,
      },
    },
  ],
};
export default {
  service,
  web: web_routers,
  cms: cms_routers,
};
